import React from "react";
import WarmUp from "./WarmUp";

const MainContainer = () => {


  return (
    <div className=" lg:absolute bg-[#C8F4F9] lg:bg-transparent w-full h-full lg:top-40 right-0">
      <WarmUp />
    </div>
  );
};

export default MainContainer;
